module.exports = __webpack_public_path__ + "Lato-LightItalic.7865ec9dc1b26d5447c7.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-LightItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-LightItalic.ttf
// module chunks = styles